module.exports = __webpack_public_path__ + "img/PKB.af6158ce.png";